import { useModalOldContext } from "@wingspanhq/fe-component-library";
import { queriesExternalBankAccounts } from "@query";
import { selectorExternalBankAccountPayoutReady } from "@selectors/selectorExternalBankAccountPayoutReady";
import { MODAL_PAYOUT_ACCOUNTS } from "../components/ModalPayoutAccounts";
import { useExternalBankAccountsPlaidLink } from "./useExternalBankAccountsPlaidLink";

export const useLinkPayoutAccount = (options?: {
  onSuccess?: () => void;
  forcePlaidOnLink?: boolean;
}) => {
  const { openModal } = useModalOldContext();
  const queryExternalBankAccounts =
    queriesExternalBankAccounts.listExternalBankAccounts.useQuery();

  const plaidHandler = useExternalBankAccountsPlaidLink({
    onSuccess: externalBankAccounts => {
      if (externalBankAccounts.length > 0) {
        openModal(MODAL_PAYOUT_ACCOUNTS, {
          onSuccess: options?.onSuccess
        });
      }
    }
  });

  return {
    linkPayoutAccount: () => {
      const externalBankAccounts = queryExternalBankAccounts.data?.data || [];

      const filteredAccounts = externalBankAccounts.filter(
        selectorExternalBankAccountPayoutReady
      );

      if (options?.forcePlaidOnLink || filteredAccounts.length === 0) {
        plaidHandler.open();
      } else {
        openModal(MODAL_PAYOUT_ACCOUNTS, {
          onSuccess: options?.onSuccess
        });
      }
    },
    plaidHandler,
    createAccountMeta: plaidHandler.meta
  };
};
